import { render, staticRenderFns } from "./CustomerMetaData.vue?vue&type=template&id=391eca3d&scoped=true&"
import script from "./CustomerMetaData.vue?vue&type=script&lang=js&"
export * from "./CustomerMetaData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMetaData.vue?vue&type=style&index=0&id=391eca3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391eca3d",
  null
  
)

export default component.exports